import React from "react";

/**
 * Cadastre360™ approved sovereign logo lockup.
 * Asset supplied by product governance — used exactly as approved.
 *
 * • Backdrop keyed to transparency (with edge decontamination) so the mark
 *   integrates seamlessly with any surface — no rectangular halo remains.
 * • Native 1500×640 raster → served as a high-DPI PNG (SVG unavailable from
 *   the approved artefact). Rendered at CSS pixel sizes far below native
 *   resolution so Retina and 4K displays receive crisp anti-aliased edges.
 * • `size` prop is a base height; when `responsive` is true (default) the
 *   height fluidly scales with the viewport within `[size, size × 1.15]` on
 *   large screens and down to ~78% on very small phones — preserving legibility
 *   of the wordmark and subtitle at every breakpoint.
 */
const LOGO_SRC = "/cadastre360-logo.png";
const ASPECT = 1450 / 620;

// Cache-bust so users receive the latest cleanly-keyed transparent asset.
const LOGO_QS = "?v=3";

export const BrandMark = ({ size = 64, responsive = true, className = "" }) => {
  const min = Math.round(size * 0.72);
  const max = Math.round(size * 1.08);
  // Fluid scaling: base with viewport component. Ensures desktop stays at full
  // masthead scale, tablets scale proportionally, mobile drops gracefully to `min`.
  const height = responsive
    ? `clamp(${min}px, calc(${size * 0.55}px + 3.8vw), ${max}px)`
    : `${size}px`;
  return (
    <img
      src={LOGO_SRC + LOGO_QS}
      alt="Cadastre360 — Zimbabwe National Cadastre"
      draggable={false}
      className={`object-contain select-none ${className}`}
      style={{
        height,
        width: `calc(${height} * ${ASPECT})`,
        imageRendering: "auto",
        // Treat the crest+text lockup as a single optical unit: no baseline
        // shift from surrounding inline flow, always centred within its box.
        display: "block",
        verticalAlign: "middle",
        objectPosition: "center center",
        alignSelf: "center",
      }}
    />
  );
};

export const BrandWordmark = ({ compact = false }) => (
  <div className="flex items-center justify-center leading-none">
    <BrandMark size={compact ? 52 : 76} />
  </div>
);
